import { render, staticRenderFns } from "./MissingRequiredWarningIcon.vue?vue&type=template&id=4605cd88&scoped=true"
import script from "./MissingRequiredWarningIcon.vue?vue&type=script&lang=js"
export * from "./MissingRequiredWarningIcon.vue?vue&type=script&lang=js"
import style0 from "./MissingRequiredWarningIcon.vue?vue&type=style&index=0&id=4605cd88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4605cd88",
  null
  
)

export default component.exports